import { useEffect, useState } from "react";
import Api from "../../../api/Api";
import CalendarAuditsBlock from "./CalendarAuditsBlock";


const getFacilityData = async () => {
    try {
        const response = await Api({
            method: "get",
            url: "/facilities/",
            headers: {},
        });
        return response.data;
    } catch (error) {
        throw `Ошибка при подгрузке данных о заводах. \n ${error}`;
    }
};

const getAudits = async () => {
    try {
        const response = await Api({
            method: "get",
            url: "/audits/my_audits/all",
            headers: {},
        });
        return response.data;
    } catch (error) {
        throw `Ошибка при подгрузке данных обо всех аудитах: \n ${error}`;
    }
};


const AuditFetchData = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [block, setBlock] = useState(false);

    const [errorInfo, setErrorInfo] = useState(null);
    const [data, setData] = useState(null);
    const [dataFacility, setDataFacility] = useState(null);

    useEffect(() => {
        const setUp = async () => {
            setLoading(true);
            try {
                const audits_data = await getAudits();
                const facilities = await getFacilityData();
                setData(audits_data);
                setDataFacility(facilities);
                setBlock(true);
            } catch (err) {
                setErrorInfo(err);
                setError(true);
            }
            setLoading(false);
        };
        setUp();
    }, []);

    if (loading) return <div className="m-1">Загрузка...</div>;
    if (error) return <p className="warning_text">{errorInfo}</p>;
    if (block) return <CalendarAuditsBlock facilityData={dataFacility} data={data} />;

    return null;
};


export const CalendarPageBlock = () => <AuditFetchData />;
